const triggerCustomerProfile = (sessionId, token, country, language) => {
    const headersAddCustomer = new Headers();
    const countryUpperCase = country.toUpperCase();
    const uniqueId = `web-` + generateUniqueID();
    const uniqueIdCorrelation = `web-` + generateUniqueID();
    headersAddCustomer.append("x-wu-operationname", "customerProfile");
    headersAddCustomer.append("Content-Type", "application/json");
    headersAddCustomer.append("x-wu-accesscode", "RtYV3XDz9EA");
    headersAddCustomer.append("wucountrycode", countryUpperCase);
    headersAddCustomer.append("wulanguagecode", language);
    headersAddCustomer.append("x-wu-externalRefId", uniqueId);
    headersAddCustomer.append("x-wu-correlationId", uniqueIdCorrelation);
    headersAddCustomer.append("flowName", `PRE_REGISTRATION`);
    headersAddCustomer.append("x-wu-session-version", `2`);
    headersAddCustomer.append("version", `V2`);
    headersAddCustomer.append("x-wu-sessionId", sessionId);
    headersAddCustomer.append("x-wu-apiKey", `1978`);
    headersAddCustomer.append("accept-language", `en-${countryUpperCase}`);
    headersAddCustomer.append("authorization", `Bearer ${token}`);
  
    const graphql = JSON.stringify({
      query: customerProfileGraphqlQuery
    });
    const requestOptions = {
      method: "POST",
      headers: headersAddCustomer,
      body: graphql,
      redirect: "follow",
    };
  
    return fetchApiWu(routerUrl, requestOptions,"customerProfile")
      .then((result) => {
        return Promise.resolve(
          result
        );
      })
      .catch((error) => console.log("triggerRouterAddCustomer Data not found: ", error));
  };

  window.queryData.triggerCustomerProfile = triggerCustomerProfile;